import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT, inject, Injectable, OnDestroy, PLATFORM_ID, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DocumentTitleService implements OnDestroy {
  private document = inject(DOCUMENT);

  readonly title = signal(this.document.title);

  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  private observer: MutationObserver | null = null;

  constructor() {
    if (!this.isBrowser) return;

    const titleElement = this.document.querySelector('title');
    if (!titleElement) return;

    this.observer = new MutationObserver(() => this.title.set(this.document.title));
    this.observer.observe(titleElement, { characterData: true, childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
